/*
 * File: fade-slide.vue.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:51:11
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop, Watch } from "vue-property-decorator";

enum AnimationDirection {
    RTL,
    LTR,
}

type AnimationMode = "single" | "group";

@Component
export default class FadeSlide extends Vue {
    /// public ///////////////////////////////////////////////////////////////////////////
    /// direct props ////////////////////////////
    @Prop({
        type: Number,
        default: 0,
    })
    step!: number;

    @Prop({
        type: String,
        required: false,
        default: "single",
    })
    type!: AnimationMode;
    //////////////////////////////////////////////////////////////////////////////////////

    /// private //////////////////////////////////////////////////////////////////////////
    /// private helper
    @Watch("step")
    private onStepChanged(newValue: number, oldValue: number) {
        this.animeDirection =
            newValue >= oldValue ? AnimationDirection.LTR : AnimationDirection.RTL;
    }

    /// handle animation
    private beforeEnter(el) {
        /// todo: this style breaks the MainApp padding and margin.
        // el.style.width = "inherit";
        // el.style.height = "inherit";
    }
    private beforeLeave(el) {
        el.style.width = `${el.offsetWidth}px`;
        el.style.height = `${el.offsetHeight}px`;
    }
    private animeDirection: AnimationDirection = AnimationDirection.LTR;
    private get animeName() {
        return "fade-slide";
    }
    //////////////////////////////////////////////////////////////////////////////////////
}
